// extracted by mini-css-extract-plugin
export default {"wrapper":"ServicesCategories_wrapper__b7gUE","content":"ServicesCategories_content__Vy355","content__header":"ServicesCategories_content__header__4AhzF"};